import React, { useEffect, useState } from 'react';
import './AnuncioGanador.css'; // Asegúrate de que el archivo CSS esté importado

const AnuncioGanador = ({ dataInfo}) => {
    const [numeroGanador, setNumeroGanador] = useState('')
    const [nombreGanador, setNombreGanador] = useState('')
    useEffect(()=>{
        if(dataInfo.data.sorteo.ganador){
            setNumeroGanador(dataInfo.data.sorteo.ganador)
            setNombreGanador(dataInfo.data.sorteo.nombreGanador)
        }
    },[dataInfo])
    return (
        <div className="anuncioGanador">
            <h1>¡Sorteo Finalizado!</h1>
            <h3>El ganador es:</h3>
            <strong>{nombreGanador}</strong>
            <p>Con el número: {numeroGanador}</p>
            <p>¡Felicidades!</p>
        </div>
    );
};

export default AnuncioGanador;
